<template lang="pug">
  .report
    PDatePicker(
      name="date"
      label="Período para descontar dos dias trabalhados"
      v-model="notWork"
      :range="true"
      format="DD/MM/YYYY"
    )
    PDatePicker(
      name="date"
      label="Período para cálculo de dias a serem trabalhados"
      v-model="toWork"
      :range="true"
      format="DD/MM/YYYY"
    )
    PTextField(v-model="reportOptions.jrnDur" :label="`${$wp('employee')} com duração de jornada menor que horas não recebem VR`" type="number" parser="float")
    PTextField(v-model="reportOptions.satDur" :label="`${$wp('employee')} com duração de jornada menor que horas no sábado não recebem VR`" type="number" parser="float")
    PCheckbox(v-model="holidayIsFolga" label="Considerar Folga nos feriados que coincidirem em dias trabalhados")
    PCheckbox(v-model="vacationIsFolga" label="Considerar Férias como Folga.")
    PCheckbox(v-model="afastIsFolga" label="Considerar afastamento em dia de trabalho como folga")

    .button
      PButton(color="success" size="md" @click="generate()" :loading="loading" :disabled="!valid") gerar excel

</template>

<script>
import moment from 'moment'

export default {
  props: {
    reportInfo: {type: Object},
    valid: {type: Boolean}
  },
  data () {
    return {
      loading: false,
      afastIsFolga: false,
      holidayIsFolga: false,
      vacationIsFolga: false,
      toWork: {
        start: moment().startOf('month').toDate(),
        end: moment().endOf('month').toDate()
      },
      notWork: {
        start: moment().startOf('month').toDate(),
        end: moment().endOf('month').toDate()
      },
      reportOptions: {
        holidayIsWork: false,
        vacationIsWork: false,
        afastIsWork: false,
        jrnDur: 6.0,
        satDur: 4.0
      }
    }
  },
  methods: {
    async generate () {
      this.loading = true

      let result

      try {
        result = await this.$API.R18.save({
          startDateToWork: moment(this.toWork.start).format('DD/MM/YYYY'),
          endDateToWork: moment(this.toWork.end).format('DD/MM/YYYY'),
          startDateNotWorked: moment(this.notWork.start).format('DD/MM/YYYY'),
          endDateNotWorked: moment(this.notWork.end).format('DD/MM/YYYY'),
          entity: this.reportInfo.entity,
          entityContent: this.reportInfo.entityContent.map(i => i.id),
          holidayIsWork: !this.holidayIsFolga,
          vacationIsWork: !this.vacationIsFolga,
          afastIsWork: !this.afastIsFolga,
          jrnDur: this.reportOptions.jrnDur !== null ? this.reportOptions.jrnDur : 6.0,
          satDur: this.reportOptions.satDur !== null ? this.reportOptions.satDur : 4.0
        })
      } catch (e) {
        result = e
      }
      this.$emit('handleReport', result)

      this.loading = false
    }
  }
}
</script>

<style scoped lang="scss">
.report {
  display: grid;
  grid-row-gap: 10px;
  .button {
    justify-self: end;

    display: grid;
    grid-auto-flow: column;
    grid-column-gap: 10px;
  }
}
</style>
